/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S7_IntroInputs */

const tr_iletisim_s7_intro = /** @type {(inputs: Iletisim_S7_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6502 sayılı Tüketicinin Korunması Hakkında Kanun kapsamında uyuşmazlıklarınızı aşağıdaki resmi kanallar üzerinden iletebilirsiniz:`)
};

const en_iletisim_s7_intro = /** @type {(inputs: Iletisim_S7_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under Law No. 6502 on Consumer Protection (Tüketicinin Korunması Hakkında Kanun), you can raise your disputes through the following official channels:`)
};

const de_iletisim_s7_intro = /** @type {(inputs: Iletisim_S7_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Rahmen des Gesetzes Nr. 6502 über den Verbraucherschutz (Tüketicinin Korunması Hakkında Kanun) können Sie Ihre Streitigkeiten über die folgenden offiziellen Kanäle geltend machen:`)
};

const ru_iletisim_s7_intro = /** @type {(inputs: Iletisim_S7_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В рамках Закона № 6502 о защите прав потребителей (Tüketicinin Korunması Hakkında Kanun) вы можете направить свои споры по следующим официальным каналам:`)
};

/**
* | output |
* | --- |
* | "Under Law No. 6502 on Consumer Protection (Tüketicinin Korunması Hakkında Kanun), you can raise your disputes through the following official channels:" |
*
* @param {Iletisim_S7_IntroInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s7_intro = /** @type {((inputs?: Iletisim_S7_IntroInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S7_IntroInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s7_intro(inputs)
	if (locale === "de") return de_iletisim_s7_intro(inputs)
	if (locale === "ru") return ru_iletisim_s7_intro(inputs)
	return tr_iletisim_s7_intro(inputs)
});